import React, { useEffect, useRef } from 'react';
import { scssVariables as variables } from 'src/helpers';

const bytesToMB = (b) => (b ? (b / (1024 * 1024)).toFixed(1) : '0.0');

const UploadProgress = ({
  progress = 0,
  bytesUploaded = 0,
  bytesTotal = 0,
  status,
  onCancel,
  size = 60,
  strokeWidth = 4,
  showBytes = true,
  style,
  bytesStyle,
  wrapperStyle = {},
  engine,
  startDate = 0,
  progressDate = 0,
  file = {},
  small = false,
  iconSize = 30
}) => {
  // console.log('uploadProgress render', bytesUploaded, bytesTotal, progress, status);
  if (!bytesTotal) showBytes = false;
  if (small) {
    size = 40;
    strokeWidth = 2;
    iconSize = 20;
  }
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progressRef = useRef(0);

  const isSuccess = status === 'success';
  const isUploading = status === 'uploading';

  useEffect(() => {
    progressRef.current = isSuccess ? 100 : progress;
  }, [progress, isSuccess]);

  const strokeDashoffset = circumference - (circumference * (isSuccess ? 100 : progress)) / 100;
  const uploadTime = progressDate ? progressDate - startDate : 0;
  const uploadTimeDisplay =
    uploadTime > 1000 ? `${(uploadTime / 1000).toFixed(1)}s` : `${uploadTime}ms`;

  const handleCancel = () => {
    console.log('onPress cancel', file);
    if (typeof onCancel === 'function') {
      onCancel(file);
    }
    if (file && typeof file.cancelUpload === 'function') {
      file.cancelUpload();
    }
  };
  // console.log('UploadProgress render', small);

  return (
    <div className={small ? 'upload-progress-wrapper' : ''} style={wrapperStyle}>
      {showBytes && (
        <div className='upload-progress-bytes' style={bytesStyle}>
          <span className='upload-progress-text'>
            {`${bytesToMB(bytesUploaded)} MB / ${bytesToMB(bytesTotal)} MB`}
          </span>
        </div>
      )}
      {engine && (
        <div className='upload-progress-engine'>
          <span className='upload-progress-text'>{`${engine}: ${uploadTimeDisplay}`}</span>
        </div>
      )}
      {status !== 'sent' && (
        <button
          disabled={!isUploading}
          onClick={handleCancel}
          className={`upload-progress-container ${!isUploading ? 'disabled' : ''}`}
          style={{ width: size, height: size, ...style }}
        >
          <svg width={size} height={size} className='upload-progress-svg'>
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke='rgba(255, 255, 255, 0.3)'
              strokeWidth={strokeWidth}
              fill='none'
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke={variables['colors-mc-primary']}
              strokeWidth={strokeWidth}
              fill='none'
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap='round'
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
              className='upload-progress-circle'
            />
          </svg>

          <div className='upload-progress-icon'>
            {status === 'uploading' && (
              <svg
                width={iconSize}
                height={iconSize}
                viewBox='0 0 24 24'
                fill={variables['colors-mc-primary']}
              >
                <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
              </svg>
            )}
            {status === 'success' && (
              <svg
                width={iconSize}
                height={iconSize}
                viewBox='0 0 24 24'
                fill={variables['colors-mc-primary']}
              >
                <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
              </svg>
            )}
            {status === 'error' && <span className='upload-progress-error'>!</span>}
          </div>
        </button>
      )}
    </div>
  );
};

export default UploadProgress;
